// extracted by mini-css-extract-plugin
export default {"dropTarget":"drop-target__ULEL2W8D","indicator":"indicator__SLmQaBaN"};